import { Logo } from './Logo'

interface Props {
  onScrollToSizer: () => void
  onArchitectGpu: () => void
  onContact: () => void
  onCapStatement: () => void
}

export function Footer({ onScrollToSizer, onArchitectGpu, onContact, onCapStatement }: Props) {
  return (
    <footer className="bg-navy text-white">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Logo height={28} variant="dark" showWordmark />
            <p className="mt-4 text-sm text-white/65 leading-relaxed">
              CyLogic builds, operates, and continuously monitors CyCloud — a sovereign
              cloud platform for federal contractors and regulated enterprises requiring
              the highest level of security, compliance, and control over sensitive data.
            </p>
          </div>

          <FooterCol title="The CyCloud platform">
            <FooterLink onClick={onScrollToSizer}>CyCloud S</FooterLink>
            <FooterLink onClick={onScrollToSizer}>CyCloud M</FooterLink>
            <FooterLink onClick={onScrollToSizer}>CyCloud L</FooterLink>
            <FooterLink onClick={onArchitectGpu}>CyCloud + GPU — architect-led</FooterLink>
          </FooterCol>

          <FooterCol title="Resources">
            <FooterLink onClick={onCapStatement}>Capability statement</FooterLink>
            <FooterLink onClick={onCapStatement}>Reference architecture</FooterLink>
            <FooterLink onClick={onScrollToSizer}>Sizer</FooterLink>
          </FooterCol>

          <FooterCol title="Company">
            <a
              href="https://cylogic.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/80 hover:text-mint transition-colors text-left"
            >
              About CyLogic
            </a>
            <FooterLink onClick={onContact}>Contact</FooterLink>
          </FooterCol>
        </div>

        <div className="mt-12 pt-8 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <div className="text-xs text-white/50 font-data">
            CyLogic, Inc. — sovereign cloud, operated.
            <br />
            © 2026 CyLogic, Inc. All rights reserved.
          </div>
          <div className="text-xs text-white/50 font-data">
            FedRAMP High Ready · pursuing Authorization
          </div>
        </div>
      </div>
    </footer>
  )
}

function FooterCol({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h4 className="font-data text-xs uppercase tracking-wide text-mint font-medium mb-4">
        {title}
      </h4>
      <ul className="space-y-2.5">
        {Array.isArray(children) ? (
          children.map((c, i) => <li key={i}>{c}</li>)
        ) : (
          <li>{children}</li>
        )}
      </ul>
    </div>
  )
}

function FooterLink({ onClick, children }: { onClick: () => void; children: React.ReactNode }) {
  return (
    <button
      onClick={onClick}
      className="text-sm text-white/80 hover:text-mint transition-colors text-left"
    >
      {children}
    </button>
  )
}
